import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import EmployeeModel from "../../models/party/employee-model";
import EmployeeTypeModel from "../../models/party/employeetype-model";

const url = getEndPoint(API_END_POINT.PARTY) +"/api/Employee/GetAllEmployee";// //{/api/Employee/GetAllemployee}`)  //// "https://localhost:7054/api/CardCustomer/GetAllCardCustomer";
export const useGetEmployee = createQuery<
  EmployeeModel[],
  null,
  AxiosError
>({
  queryKey: ["keyEmployeepage"],
  fetcher: (params) =>
        getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
        // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});

const employeeTypeUrl = getEndPoint(API_END_POINT.PARTY) +"/api/Employee/GetAllEmployeeType";// //{/api/Employee/GetAllemployee}`)  //// "https://localhost:7054/api/CardCustomer/GetAllCardCustomer";
export const useGetEmployeeType = createQuery<
  EmployeeTypeModel[],
  null,
  AxiosError
>({
  queryKey: ["keyEmployeeTypepage"],
  fetcher: (params) =>
        getDataWithToken<any>(employeeTypeUrl).then((response) => response.data?.result || console.log(response)),
        // axios.get(employeeTypeUrl, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});

